import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import { CHATBOT_INTERACT, CHATBOT_VOICETOTEXT } from "./actionType";

import {
  chatbotInteractSuccess,
  chatbotInteractFailure,
  chatbotVoiceToTextSuccess,
  chatbotVoiceToTextFailure,
} from "./action";

import {
  chatbotInteractApi,
  chatbotVoiceToTextApi,
} from "../../helpers/fakebackend_helper";

//CHATBOT_INTERACT
function* chatbotInteractLocalCall(action) {
  try {
    const response = yield call(chatbotInteractApi, action.payload);
    yield put(chatbotInteractSuccess(response));
  } catch (error) {
    yield put(chatbotInteractFailure(error));
  }
}

function* watchChatbotInteract() {
  yield takeEvery(CHATBOT_INTERACT, chatbotInteractLocalCall);
}

//CHATBOT_VOICETOTEXT
function* chatbotVoiceToTextLocalCall(action) {
  try {
    const response = yield call(chatbotVoiceToTextApi, action.payload);
    yield put(chatbotVoiceToTextSuccess(response));
  } catch (error) {
    yield put(chatbotVoiceToTextFailure(error));
  }
}

function* watchChatbotVoiceToText() {
  yield takeEvery(CHATBOT_VOICETOTEXT, chatbotVoiceToTextLocalCall);
}
export default function* ChatCrmit() {
  yield all([fork(watchChatbotInteract), fork(watchChatbotVoiceToText)]);
}
